import React, { useState, useEffect } from 'react';
import './title-screen.css';
import { connect } from 'react-redux';
import {
    GAME_SETTINGS_SCREEN,
    QUICKPLAY_SCREEN,
    SETTINGS_SCREEN,
} from '../../constants/routes';
import { TitleScreenBanner } from './title-screen-banner';
import { IconButton } from '../../components/icon-button';
import { goToScreen } from '../../actions/router';
import { Paragraph } from '../../components/paragraph';
import { ActivityIndicator } from '../../components/activity-indicator';
import classNames from 'classnames';
import { allBackgrounds } from '../../helpers/background';
import { allAnimations } from '../../helpers/animations';
import { allPngs } from '../../helpers/icon';
import { setAllMeetings, setAllMessages } from '../../actions/active-game';
import { getMessagesOrMeetings } from '../../helpers/active-game';
import { setGameSettings } from '../../actions/settings';

const TitleScreen = props => {
    const { goToScreen, setQuickplaySettings } = props;

    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const loadImage = (src, type) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = resolve;
                img.onerror = reject;
                img.src = src;
            });
        };

        const loadAllImages = images => {
            Promise.all(images.map(image => loadImage(image))).finally(() =>
                setImagesLoaded(true),
            );
        };

        loadAllImages([...allBackgrounds, ...allAnimations, ...allPngs]);
    }, []);

    const [
        smallScreenStartExperience,
        setSmallScreenStartExperience,
    ] = useState(false);

    const titleScreenOptionsFirstPageClasses = classNames({
        'title-screen__option': true,
        'title-screen__option--small-screen': true,
        'title-screen__option--hidden': smallScreenStartExperience === true,
    });

    const titleScreenOptionsSecondPageClasses = classNames({
        'title-screen__option': true,
        'title-screen__option--hidden': smallScreenStartExperience === false,
    });

    return (
        <>
            <TitleScreenBanner
                smallScreenStartExperience={smallScreenStartExperience}
            />
            {smallScreenStartExperience === true && (
                <IconButton
                    iconName="back"
                    onClick={() => {
                        setSmallScreenStartExperience(false);
                    }}
                    type="essential"
                    size="small"
                    withSpacing={true}
                />
            )}
            <div className="title-screen__options">
                <div
                    className={titleScreenOptionsFirstPageClasses}
                    aria-hidden={smallScreenStartExperience === true}
                >
                    <Paragraph
                        colorScheme="dark"
                        fontWeight="bold"
                        fontSize="large"
                        withSpacing={false}
                    >
                        Start
                    </Paragraph>
                    {imagesLoaded ? (
                        <IconButton
                            iconName="enter"
                            type="main"
                            size="small"
                            onClick={() => setSmallScreenStartExperience(true)}
                            altText="start"
                        />
                    ) : (
                        <ActivityIndicator size="small" />
                    )}
                </div>
                <div className={titleScreenOptionsSecondPageClasses}>
                    <Paragraph
                        colorScheme="dark"
                        fontWeight="bold"
                        fontSize="large"
                        withSpacing={false}
                    >
                        Start your week
                    </Paragraph>
                    {imagesLoaded ? (
                        <IconButton
                            iconName="enter"
                            type="main"
                            size="small"
                            onClick={() => {
                                goToScreen(GAME_SETTINGS_SCREEN);
                            }}
                            altText="Start your week"
                        />
                    ) : (
                        <ActivityIndicator size="small" />
                    )}
                </div>
                <div className={titleScreenOptionsSecondPageClasses}>
                    <Paragraph
                        colorScheme="dark"
                        fontWeight="bold"
                        fontSize="large"
                        withSpacing={false}
                    >
                        Quickplay
                    </Paragraph>
                    {imagesLoaded ? (
                        <IconButton
                            iconName="enter"
                            type="main"
                            size="small"
                            onClick={() => {
                                goToScreen(QUICKPLAY_SCREEN);
                                setQuickplaySettings();
                            }}
                            altText="Quickplay"
                        />
                    ) : (
                        <ActivityIndicator size="small" />
                    )}
                </div>
            </div>
            <IconButton
                iconName="settings"
                onClick={() => {
                    goToScreen(SETTINGS_SCREEN);
                }}
                type="essential"
                size="small"
                withSpacing={true}
            />
        </>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        goToScreen: route => {
            dispatch(goToScreen(route));
        },
        setQuickplaySettings: () => {
            dispatch(setGameSettings('easy', 'government'));
            dispatch(
                setAllMessages(
                    getMessagesOrMeetings('government', 'easy', 'messages'),
                ),
            );
            dispatch(
                setAllMeetings(
                    getMessagesOrMeetings('government', 'easy', 'meetings'),
                ),
            );
        },
    };
};

const connected = connect(null, mapDispatchToProps)(TitleScreen);
export { connected as TitleScreen };
